// В.2.e-2: общий каркас триггеров «когда этот юнит получает урон».
//
// API:
//   registerOnDamageTakenTrigger(cardId, fn)
//     — fn(state, target, damageToHp, armorAbsorbed) вызывается каждый раз,
//       когда target.id === cardId реально потерял ХП от удара. damageToHp =
//       сколько ХП ушло в hp (после Брони, после Иммунитета). armorAbsorbed
//       — сколько в Броню. Если обе суммы === 0 (Иммунитет всё поглотил) —
//       fn НЕ вызывается (нет «потерянных ХП»).
//   fireOnDamageTakenTrigger(state, target, damageToHp, armorAbsorbed)
//     — вызывается из combat.applyDamage сразу после применения урона,
//       ДО проверки смерти. Молчание цели блокирует.

const _onDamageTakenTriggers = new Map();

export function registerOnDamageTakenTrigger(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  _onDamageTakenTriggers.set(cardId, fn);
}

export function _resetOnDamageTakenTriggersForTests() {
  _onDamageTakenTriggers.clear();
}

// damageToHp — целое >=0 (только hp-составляющая). armorAbsorbed — целое >=0.
// По диздоку Альфы: «за каждый потерянный ХП +1 atk» — учитываем только
// damageToHp. Броня не считается «потерянным ХП», т.к. ХП у юнита не упал.
// Этап 56.55: добавлен 5-й параметр attacker (источник урона) — нужен
// Подмазанному стукачу (Молчание атакующему). Существующие триггеры его
// игнорируют (обратносовместимо). attacker может быть null (урон без юнита-
// источника: AoE-Действие, DoT и т.п.).
export function fireOnDamageTakenTrigger(state, target, damageToHp, armorAbsorbed = 0, attacker = null) {
  if (!target) return;
  if (_onDamageTakenTriggers.size === 0) return;
  if (damageToHp <= 0) return;
  const fn = _onDamageTakenTriggers.get(target.id);
  if (!fn) return;
  // Молчание цели — блокирует её собственный триггер.
  if (target.current?.silenced) return;
  if (target.silenceSources && target.silenceSources.size > 0) return;
  try {
    fn(state, target, damageToHp | 0, armorAbsorbed | 0, attacker);
  } catch (e) {
    console.warn(`[Корпы] on_damage_taken-триггер ${target.id} упал:`, e);
  }
}
